<template>
  <div class="counter-component-container">
    <div
      :class="`counter text-xs font-medium text-secondary ${primary ? 'primary' : ''}`"
    >
      {{ count }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      count: {
        type: Number,
        default: 0,
      },
      primary: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style lang='scss' scoped>
.counter-component-container {
  text-align: left;

  .counter {
    background-color: var(--bg-secondary);
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-full);
    padding: var(--spacing-xxs) var(--spacing-md);

    &.primary {
      background-color: var(--bg-brand-primary);
      border-color: var(--utility-brand-200);
      color: var(--utility-brand-700);
    }
  }
}
</style>
